import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import provideRenderToLayer from '../hoc/provide-render-to-layer';
export default function providePopup(Target) {
  var ProvidePopup = /*#__PURE__*/function (_Component) {
    _inherits(ProvidePopup, _Component);

    var _super = _createSuper(ProvidePopup);

    function ProvidePopup() {
      var _this;

      _classCallCheck(this, ProvidePopup);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.openPopup = function (createElement) {
        var popup = {};
        var onOpen;
        var onResolve;
        var onReject;
        popup.opened = new Promise(function (resolve) {
          onOpen = resolve;
        });
        popup.closed = new Promise(function (resolve, reject) {
          onResolve = function onResolve(arg) {
            _this.props.unrenderAtLayer(popup.element).then(function () {
              resolve(arg);
            });
          };

          onReject = function onReject(arg) {
            _this.props.unrenderAtLayer(popup.element).then(function () {
              reject(arg);
            });
          };
        });
        popup.element = _this.props.renderToLayer(createElement(onResolve, onReject), {
          onOpen: onOpen,
          onRequestClose: onReject
        });
        popup.close = onReject;
        return popup;
      };

      _this.closePopup = function (popup) {
        popup.close();
      };

      return _this;
    }

    _createClass(ProvidePopup, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            renderToLayer = _this$props.renderToLayer,
            unrenderAtLayer = _this$props.unrenderAtLayer,
            props = _objectWithoutProperties(_this$props, ["renderToLayer", "unrenderAtLayer"]);

        return React.createElement(Target, _extends({}, props, {
          openPopup: this.openPopup,
          closePopup: this.closePopup
        }));
      }
    }]);

    return ProvidePopup;
  }(Component);

  ProvidePopup.propTypes = process.env.NODE_ENV !== "production" ? {
    renderToLayer: PropTypes.func.isRequired,
    unrenderAtLayer: PropTypes.func.isRequired
  } : {};
  return provideRenderToLayer(ProvidePopup);
}